// extracted by mini-css-extract-plugin
module.exports = {"addToWatchlist":"ModalPurchaseInProgress_addToWatchlist__ZYnVu"};